import { render, staticRenderFns } from "./addIntervene.vue?vue&type=template&id=19b68957&scoped=true&"
import script from "./addIntervene.vue?vue&type=script&lang=js&"
export * from "./addIntervene.vue?vue&type=script&lang=js&"
import style0 from "./addIntervene.vue?vue&type=style&index=0&id=19b68957&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b68957",
  null
  
)

export default component.exports